<template>
    <div v-if="!$store.state.loading">
        <TheFilters></TheFilters>
        <SearchResultsCoureurs></SearchResultsCoureurs>
        <b-row>
            <b-col md="8">
                <StatistiquesCourse></StatistiquesCourse>
            </b-col>
            <b-col md="4">
                <ThePagination></ThePagination>
            </b-col>
        </b-row>
        <TheTable></TheTable>

    </div>
</template>

<script>
import TheFilters from "@/components/Live_tab/ListCoureurs/TheFilters.vue";
import SearchResultsCoureurs from "@/components/Live_tab/ListCoureurs/SearchResultsCoureurs.vue";
import StatistiquesCourse from "@/components/Live_tab/ListCoureurs/StatistiquesCourse.vue";
import ThePagination from "@/components/Live_tab/ListCoureurs/ThePagination.vue";
import TheTable from "@/components/Live_tab/ListCoureurs/TheTable.vue";
export default {
    components: {
        TheFilters,
        SearchResultsCoureurs,
        StatistiquesCourse,
        ThePagination,
        TheTable
    },
    computed: {
        participants() {
            return this.$store.getters["listCoureurs/participants"];
        },
        courseFilter() {
            return this.$store.getters["listCoureurs/courseFilter"];
        },
        sortby() {
            return this.$store.getters["listCoureurs/sortby"];
        },
        page() {
            return this.$store.getters["listCoureurs/page"];
        },
        perPage() {
            return this.$store.getters["listCoureurs/perPage"];
        },
        fields() {
            return this.$store.getters["listCoureurs/fields"];
        },
        translated_stats() {
            // Traduction des stats
            var translated_stats = "";
            if (this.participants.stats_inscriptions) {
                var raw_stats = this.participants.stats_inscriptions.split("-");
                for (var i = 0; i < raw_stats.length; i++) {
                    var raw_item_stat = raw_stats[i].split(":");
                    if (raw_item_stat[0].includes("Inscrits")) {
                        raw_item_stat[0] = this.$t("inscrits");
                    } else if (raw_item_stat[0].includes("Partis")) {
                        raw_item_stat[0] = this.$t("partis");
                    } else if (raw_item_stat[0].includes("Arrivés")) {
                        raw_item_stat[0] = this.$t("arrives");
                    } else if (raw_item_stat[0].includes("Abandons")) {
                        raw_item_stat[0] = this.$t("abandons");
                    }
                    translated_stats += raw_item_stat[0] + " : " + raw_item_stat[1];
                    if (i < raw_stats.length - 1) {
                        translated_stats += " - ";
                    }
                }
            }
            return translated_stats;
        }
    },
    watch: {
        sortby() {
            this.$store.commit("listCoureurs/setPage", 1);
            this.$store.dispatch("listCoureurs/fetchInscriptions");
        }
    },
    created() {
        this.$store.commit("setLoading");
        this.$store.commit("clearRefreshIntervals");

        // Initialisation du filtre de course depuis la route ou le store
        if (this.$route.params.course && this.$route.params.course != "") {
            this.$store.commit("listCoureurs/setCourseFilter", this.$route.params.course);
            this.$store.state.selected_live_course = this.$route.params.course;
        } else if (this.$store.state.selected_live_course && this.$store.state.selected_live_course != "") {
            this.$store.commit("listCoureurs/setCourseFilter", this.$store.state.selected_live_course);
        }
        else {
            const firstParcours = this.$store.getters["parcours/firstParcours"];
            this.$store.commit("listCoureurs/setCourseFilter", firstParcours.nom);
            this.$store.state.selected_live_course = firstParcours.nom;
        }

        // Gestion des adaptateurs de vue spécifiques
        if (this.$store.getters['authAdmin/hasAdminRights']) {
            this.$store.dispatch("listCoureurs/view_adapter_pc_course");
        }

        if (this.$route.params.base === "BONETTE23") {
            this.$store.dispatch("listCoureurs/view_adapter_BONETTE23");
        }

        if (this.$route.params.base === "MERIB22") {
            if (this.$store.state.selected_live_course === "CDF - Kilomètre vertical") {
                this.$store.dispatch("listCoureurs/view_adapter_MERIB22_KV");
            } else {
                this.$store.dispatch("listCoureurs/unset_view_adapter_MERIB22_KV");
            }
        }

        this.$store.dispatch("listCoureurs/fetchInscriptions");
        this.$store.dispatch("listCoureurs/countdownRefresh");
    }
}
</script>

<style lang="scss" scoped></style>